import { useEffect, useState } from 'react';
import { Card } from 'antd';

import Footer from '../../components/Footer';
import { Header } from '../../components/Header';
import { Card as CustomCard } from './components/Card';

import { Container, Content, SearchBar } from './styles';
import { FiSearch } from 'react-icons/fi';
import { apiNode } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { SuccessAcceptUserModal } from './components/SuccessAcceptUserModal';
import { normalizeString } from '../../utils/normalizeString';

interface RequestProps {
  id: number;
  user: {
    name: string;
    foto: string;
  };
}

export const LeagueNotifications = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const [requests, setRequests] = useState<RequestProps[]>([]);
  const [filteredRequests, setFilteredRequests] = useState<RequestProps[]>([]);
  const [selectedRequest, setSelectedRequest] = useState<RequestProps>(
    {} as RequestProps
  );

  const [isSuccessAcceptUserModalOpen, setIsSuccessAcceptUserModalOpen] =
    useState(false);

  useEffect(() => {
    try {
      setIsLoading(true);
      const getRequests = async () => {
        const leagueResponse = await apiNode.get('/ligas/users');

        const { isAdmin } = leagueResponse.data.participante;
        const { id } = leagueResponse.data.liga;

        if (!isAdmin) {
          navigate('/leagues');
          return;
        }

        const requestsResponse = await apiNode.get(
          `/ligas/${id}/listar/pedidos`
        );

        setIsLoading(false);
        setRequests(requestsResponse.data.pedidos);
        setFilteredRequests(requestsResponse.data.pedidos);
      };

      getRequests();
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, [navigate]);

  const handleOpenSuccessModal = (request: RequestProps) => {
    setIsSuccessAcceptUserModalOpen(true);
    setSelectedRequest(request);
  };

  const updateRequestsList = (id: number) => {
    let newRequestsList: RequestProps[] = [];

    requests.forEach((request) => {
      if (request.id !== id) {
        newRequestsList.push(request);
      }
    });

    setRequests(newRequestsList);
  };

  const filterRequestsByUsername = (word: string) => {
    const newFilteredRequestsList: RequestProps[] = [];

    requests.forEach((request) => {
      if (normalizeString(request.user.name).includes(normalizeString(word))) {
        newFilteredRequestsList.push(request);
      }
    });

    setFilteredRequests(newFilteredRequestsList);
  };

  return (
    <Container>
      <Header />

      <Content>
        <span>
          <h1>Notificações</h1>

          <SearchBar>
            <FiSearch size={15} />
            <input
              type="text"
              placeholder="Encontre um jogador"
              onChange={(event) => filterRequestsByUsername(event.target.value)}
            />
          </SearchBar>
        </span>

        <div>
          {isLoading && (
            <>
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
              <Card
                loading={true}
                style={{ width: '80%', marginRight: 36, marginBottom: 36 }}
              />
            </>
          )}

          {!isLoading &&
            filteredRequests.length > 0 &&
            filteredRequests.map((request) => (
              <CustomCard
                key={request.id}
                request={request}
                openSuccessModal={handleOpenSuccessModal}
                updateRequestsList={updateRequestsList}
              />
            ))}

          {!isLoading && filteredRequests.length < 1 && (
            <h1>Você não possui nenhuma notificação</h1>
          )}
        </div>
      </Content>

      <Footer />

      <SuccessAcceptUserModal
        isOpen={isSuccessAcceptUserModalOpen}
        closeModal={() => setIsSuccessAcceptUserModalOpen(false)}
        request={selectedRequest}
      />
    </Container>
  );
};
